// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pNIJ0L_sedIYhXDD {
  background-color: #ffffff;
  margin-top: 20px;
  border-radius: 10px;
  padding: 20px;
  height: calc(100vh - 150px);
  position: relative;
}

.pNIJ0L_sedIYhXDD > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
}

.pNIJ0L_sedIYhXDD h1 {
  font-size: 56px;
  text-align: center;
  line-height: 120%;
  margin-bottom: 48px;
}

.ocv7ergOfwk33VSm {
  padding: 20px 80px;
  font-size: 26px;
  background-color: #0078ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Main/Main.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B","sourcesContent":[".wrapper {\r\n  background-color: #ffffff;\r\n  margin-top: 20px;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  height: calc(100vh - 150px);\r\n  position: relative;\r\n}\r\n\r\n.wrapper > div {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 75%;\r\n}\r\n\r\n.wrapper h1 {\r\n  font-size: 56px;\r\n  text-align: center;\r\n  line-height: 120%;\r\n  margin-bottom: 48px;\r\n}\r\n\r\n.button {\r\n  padding: 20px 80px;\r\n  font-size: 26px;\r\n  background-color: #0078ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `pNIJ0L_sedIYhXDD`;
export var button = `ocv7ergOfwk33VSm`;
export default ___CSS_LOADER_EXPORT___;
